import styled from 'styled-components';
import { Palette } from '@/styles/Themes/Palette';

export const StyledLink = styled.a<{ textDecoration?: string }>`
    color: ${Palette.green.normal};
    cursor: pointer;
`;
